module.exports = __webpack_public_path__ + "static/media/1015070.2a51903b.jpg";